export const SENTRY_CONSTANTS = {
  EXCLUDE: [
    '-- pf - starting script detection'
  ]
};
